const C = {
  name: "Dna",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 2.2896V0H17V2.2904C17.0007 4.12072 16.4915 5.91505 15.5293 7.47209C14.6561 8.88528 13.4412 10.0523 12 10.8675C10.5588 10.0523 9.3439 8.88528 8.47066 7.47209C7.50853 5.91505 6.99927 4.12032 7 2.29V0H5V2.29C4.9992 4.49182 5.61186 6.65033 6.76927 8.52341C7.6189 9.89839 8.7374 11.0796 10.0513 12C8.7374 12.9204 7.6189 14.1016 6.76927 15.4766C5.61186 17.3497 4.9992 19.5086 5 21.7104V24H7V21.7096C6.99927 19.8793 7.50853 18.085 8.47066 16.5279C9.3439 15.1147 10.5588 13.9477 12 13.1325C13.4412 13.9477 14.6561 15.1147 15.5293 16.5279C16.4915 18.085 17.0007 19.8797 17 21.71V24H19V21.71C19.0008 19.5082 18.3881 17.3497 17.2307 15.4766C16.3811 14.1016 15.2626 12.9204 13.9487 12C15.2626 11.0796 16.3811 9.89839 17.2307 8.52341C18.3881 6.65033 19.0008 4.49142 19 2.2896Z" fill="currentColor"/>
<path d="M9 2H15V4H9V2Z" fill="currentColor"/>
<path d="M14 6H10V8H14V6Z" fill="currentColor"/>
<path d="M14 16V18H10V16H14Z" fill="currentColor"/>
<path d="M15 22H9V20H15V22Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Dna
};
